import {
    W9RequestDTO,
    W9RequestSearchDTO,
    W9RequestClient_V1,
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';

export default class W9RequestService {
    private readonly _w9RequestClient: W9RequestClient_V1;

    constructor() {
        this._w9RequestClient = new W9RequestClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public W9Requests(dealerAccountUid: string, dto: W9RequestSearchDTO): Promise<Array<W9RequestDTO>> {
        return this._w9RequestClient.w9Requests(dto, dealerAccountUid);
    }

    public CreateW9Request(dealerAccountUid: string, dto: W9RequestDTO): Promise<W9RequestDTO> {
        return this._w9RequestClient.createW9Request(dto, dealerAccountUid);
    }
}